import "./src/styles/tailwind.css"

// import "tailwindcss/base.css"
// import "tailwindcss/components.css"
// import "tailwindcss/utilities.css"
